import React from 'react'
import { Container, Col, Image, Row } from 'react-bootstrap';
import { NavLink, useNavigate, useParams } from 'react-router-dom'

function AllHeader({ children }) {
  const navigate = useNavigate();

  return (
    <div>
      <Container fluid className="rgc-header pt-3">
        <Row className='justify-content-center justify-content-md-around' >
          <Col xs={3} md={2} className="text-end text-md-center">
            <div className='rgc-icon-style' onClick={() => navigate(-1)}>
             <i className="fa fa-arrow-right"></i>
           </div>
          </Col>

          <Col xs={6} md={6}  className="text-center rgc-header-title">
              {children}
          </Col>

          <Col xs={3} md={2} className="text-start text-md-center">
          <NavLink to='/' aria-current="page"  className='rgc-icon-style me-auto'>         
              <i className="fas fa-home"></i>           
          </NavLink>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default AllHeader